export const version = "random/5.7.0";
//# sourceMappingURL=_version.js.map